import React from 'react'
import { Header } from 'semantic-ui-react'
import WebcamManager from './WebcamManager'


const Webcams = (props) => {
  return (
    <div>
      <Header>Вебкамеры</Header>
      <WebcamManager />
    </div>
  )
}

export default Webcams
